// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.me-show-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	padding: 0.75rem 1rem;
	background: rgb(0, 51, 51);
	border-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;
}

.me-show-info {
	flex: 1;
	min-width: 0;
}

.me-show-name {
	font-size: 0.95rem;
	font-weight: 600;
	color: #fff;
	line-height: 1.2;
}

.me-page-title {
	display: block;
	font-size: 0.65rem;
	font-weight: 700;
	letter-spacing: 0.1em;
	color: #111827;
	text-transform: uppercase;
	margin-bottom: 0.25rem;
}

.se-loading-icon {
	font-size: 2rem;
	color: #9ca3af;
}

.se-amount {
	min-width: 80px;
}

.se-amount-value {
	font-size: 0.9rem;
	font-weight: 600;
	color: #111827;
}

.se-total-amount {
	font-size: 1rem;
	font-weight: 700;
	color: #111827;
}

.min-width-0 {
	min-width: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/submit-entries/submit-entries.component.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;CACT,qBAAqB;CACrB,0BAA0B;CAC1B,4DAA4D;AAC7D;;AAEA;CACC,OAAO;CACP,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;CACrB,cAAc;CACd,yBAAyB;CACzB,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,YAAY;AACb","sourcesContent":[".me-show-header {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 1rem;\n\tpadding: 0.75rem 1rem;\n\tbackground: rgb(0, 51, 51);\n\tborder-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;\n}\n\n.me-show-info {\n\tflex: 1;\n\tmin-width: 0;\n}\n\n.me-show-name {\n\tfont-size: 0.95rem;\n\tfont-weight: 600;\n\tcolor: #fff;\n\tline-height: 1.2;\n}\n\n.me-page-title {\n\tdisplay: block;\n\tfont-size: 0.65rem;\n\tfont-weight: 700;\n\tletter-spacing: 0.1em;\n\tcolor: #111827;\n\ttext-transform: uppercase;\n\tmargin-bottom: 0.25rem;\n}\n\n.se-loading-icon {\n\tfont-size: 2rem;\n\tcolor: #9ca3af;\n}\n\n.se-amount {\n\tmin-width: 80px;\n}\n\n.se-amount-value {\n\tfont-size: 0.9rem;\n\tfont-weight: 600;\n\tcolor: #111827;\n}\n\n.se-total-amount {\n\tfont-size: 1rem;\n\tfont-weight: 700;\n\tcolor: #111827;\n}\n\n.min-width-0 {\n\tmin-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
